export default __webpack_public_path__ + "static/media/feedbackBanner.550b7216.jpg";